export const FETCH_SUCCESS = "SETTINGS_ROLES/FETCH_SUCCESS";
export const TABLE_UPDATE = "SETTINGS_ROLES/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "SETTINGS_ROLES/DESTROY_FAILED",
    DESTROY_REQUEST: "SETTINGS_ROLES/DESTROY_REQUEST",
    DESTROY_SUCCESS: "SETTINGS_ROLES/DESTROY_SUCCESS",

    FETCH_FAILED: "SETTINGS_ROLES/FETCH_FAILED",
    FETCH_REQUEST: "SETTINGS_ROLES/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "SETTINGS_ROLES/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "SETTINGS_ROLES/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "SETTINGS_ROLES/FETCH_ALL_SUCCESS",

    FETCH_PERMISSIONS_ALL_FAILED: "PERMISSIONS/FETCH_ALL_FAILED",
    FETCH_PERMISSIONS_ALL_REQUEST: "PERMISSIONS/FETCH_ALL_REQUEST",
    FETCH_PERMISSIONS_ALL_SUCCESS: "PERMISSIONS/FETCH_ALL_SUCCESS",

    GET_FAILED: "SETTINGS_ROLES/GET_FAILED",
    GET_REQUEST: "SETTINGS_ROLES/GET_REQUEST",
    GET_SUCCESS: "SETTINGS_ROLES/GET_SUCCESS",

    STORE_FAILED: "SETTINGS_ROLES/STORE_FAILED",
    STORE_REQUEST: "SETTINGS_ROLES/STORE_REQUEST",
    STORE_SUCCESS: "SETTINGS_ROLES/STORE_SUCCESS",

    UPDATE_FAILED: "SETTINGS_ROLES/UPDATE_FAILED",
    UPDATE_REQUEST: "SETTINGS_ROLES/UPDATE_REQUEST",
    UPDATE_SUCCESS: "SETTINGS_ROLES/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
